/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
export type CalendarStatus =
  | 'ACTIVE'
  | 'INACTIVE';

export type CalendarSummaryItemCalendarAssignedStaffFragment = { guid: string, displayName: string, priority: number | null };

export type CalendarSummaryItemCalendarSummaryFragment = { guid: string, status: Types.CalendarStatus, publicTitle: string, privateTitle: string | null, description: string | null, assignedStaffs: Array<{ guid: string, displayName: string, priority: number | null }> };

export const CalendarSummaryItemCalendarAssignedStaffFragmentDoc = gql`
    fragment CalendarSummaryItemCalendarAssignedStaff on CalendarAssignedStaff {
  guid
  displayName
  priority
}
    `;
export const CalendarSummaryItemCalendarSummaryFragmentDoc = gql`
    fragment CalendarSummaryItemCalendarSummary on CalendarSummary {
  guid
  status
  publicTitle
  privateTitle
  description
  assignedStaffs {
    ...CalendarSummaryItemCalendarAssignedStaff
  }
}
    ${CalendarSummaryItemCalendarAssignedStaffFragmentDoc}`;